import {BankDao} from '../../dao';
import {BankModel} from '../../models';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'UPDATE_BANK_BY_ID';

export async function updateBankById(
    userData: Record<string, string>,
    bankId: number,
    update: Record<string, any>
) {
    try {
        const result = await BankDao.updateBankById(userData.userToken, bankId, update);

        const resultParsed = BankModel.parseBank(result);

        return resultParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
